module.exports = __webpack_public_path__ + "static/media/finished-hand-draw-lines.0eb700b2.png";